export { ProtectionIcon } from './ProtectionIcon'
